var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lebo-card"},[_c('div',{staticClass:"card_heard_box"},[_c('div',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("heard-left")],2),_vm._t("heard-right")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }